// plugins/safari-scroll-fix.client.ts

/**
 * 이 플러그인이 있는 이유는 다음을 참고하세요
 * https://github.com/nuxt/nuxt/issues/27282
 *
 * 요지는 아이폰에서 스와이프백 액션을 취할때 이전페이지가 흰화면으로 보이는 문제를 해결하는 플러그인 입니다.
 * window.history.scrollRestoration 가 nuxt3 에서는 자동으로 manual 로 바뀌는데, safari 에서 이게 문제를 일으킵니다.
 */

export default defineNuxtPlugin((nuxtApp) => {
  // 1. 사용자 에이전트를 통해 iOS/Safari 환경인지 확인합니다.
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isIOS || isSafari) {
    // 2. iOS/Safari 환경인 경우, 스크롤 복원 설정을 'auto'로 변경합니다.
    //    이를 통해 스와이프 뒤로 가기 시 브라우저가 화면 스냅샷을 제대로 보여줍니다.

    // 페이지 이동이 완료된 후 설정을 변경하는 것이 안전합니다.
    useRouter().afterEach(() => {
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "auto";
      }
    });

    // 참고: 만약 이 설정이 다른 페이지에서 'manual'로 다시 변경되는 경우가 있다면,
    // 아래 코드를 추가하여 router 준비 시점에도 'auto'를 설정해 줄 수 있습니다.
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "auto";
    }
  }
});
